import { Paper, Text } from '@mantine/core'

import type { TraceStep } from '../types'
import { formatDateTime } from '../utils/format'
import { parseHubspotEventMetadata, isHubspotFailureEvent } from '../utils/hubspot-event-details'
import { HubspotApiDetails } from './HubspotApiDetails'

type Props = {
  step: TraceStep
}

export const HubspotExecutionPanel = ({ step }: Props) => {
  const isSuccess =
    step.event === 'hubspot_completed' ||
    ['company_merged', 'company_deleted', 'company_domain_updated', 'review_task_created'].includes(
      step.event
    )
  const isFailure = isHubspotFailureEvent(step.event, step.metadata)
  const details = parseHubspotEventMetadata(step.metadata, {
    companyId: step.companyId,
    companyName: step.companyName,
    domain: step.domain,
    action: step.action,
  })

  return (
    <Paper
      withBorder
      p='md'
      mb='lg'
      style={{
        borderColor: isSuccess ? '#40c057' : isFailure ? '#fa5252' : '#868e96',
        borderWidth: 2,
      }}
    >
      <Text fw={700} mb='sm' c={isFailure ? 'red' : isSuccess ? 'green' : undefined}>
        HubSpot execution — {isSuccess ? 'success' : isFailure ? 'failed' : step.event}
      </Text>

      <HubspotApiDetails
        details={details}
        message={step.message}
        variant={isFailure ? 'failure' : isSuccess ? 'success' : 'neutral'}
        action={step.action}
      />

      <Text size='xs' c='dimmed' mt='sm'>
        {formatDateTime(step.ts)}
      </Text>
    </Paper>
  )
}
